import { useScopeParams } from "@/hooks/useScopeParams";
import { PageTemplate } from "@/components/Templates/PageTemplate";

export default function Questionnaires({
  singleSubjectId,
}: {
  singleSubjectId?: string;
}) {
  const { id } = useScopeParams();
  const wikiLink = singleSubjectId
    ? "/wiki/guides/exploration-singlesubject-questionnaires"
    : "/wiki/guides/exploration-measures-questionnaires";

  return (
    <PageTemplate
      title="Measures: Questionnaires"
      tooltipText="Explore questionnaires data, create data subsets, view visualizations, and download data and visualizations."
      type="questionnaires"
      constants={{
        wikiLink,
        idLink: (subjectId: string) =>
          `/${id}/subjects/overview/${subjectId}/questionnaires`,
      }}
      subjectId={singleSubjectId}
    />
  );
}
